var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewChat = function SvgNewChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.8 2.9v1.8h-9v12.047L3.387 15.5H16.2V9.2H18v7.2a.9.9 0 0 1-.9.9H4.01L0 20.45V3.8a.9.9 0 0 1 .9-.9zm4.5 0V.2h1.8v2.7h2.7v1.8h-2.7v2.7h-1.8V4.7h-2.7V2.9z"
  })));
};
export default SvgNewChat;